<template>
  <div>
    <b-modal
      id="modal-import-file"
      ref="modal_import_file"
      title="Импорт заявок из файла"
      size="md"
      modal-class="custom-modal"
      no-close-on-backdrop
      no-close-on-esc
      centered
      @hidden="hideModal"
    >
      <b-card class="custom-card">
        <b-form-group label="Объект">
          <location-select
            id="input-location-select"
            ref="location_select"
            @onSelect="onLocationChange"
          />
        </b-form-group>
        <b-form-group label="Адрес объекта">
          <b-form-input
            id="input-start-address"
            size="sm"
            type="text"
            placeholder="Введите адрес объекта"
            v-model="newItem.start_address"
          />
        </b-form-group>
        <b-row>
          <b-col cols="6">
            <b-form-group label="Менеджер">
              <user-select
                id="input-user-select"
                ref="user_select"
                :is-disabled="newItem.location_id === 0"
                @onSelect="onSelectExecutor"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Руководитель">
              <b-form-input
                class="text-small"
                size="sm"
                type="text"
                disabled
                :value="newItem.project_id != null ? newItem.project_name : '-'"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label="Вид работ объекта">
          <location-works-select
            id="location-works-select"
            class="mb-3"
            ref="location_works_select"
            @onSelect="onLocationWorkSelect"
          />
        </b-form-group>
        <b-list-group horizontal>
          <b-form-file
            size="sm"
            v-model="importFile"
            accept=".xlsx, .xls"
            browse-text="Выбрать"
            placeholder="Файл не выбран"
          />
          <b-button size="sm" variant="danger" @click="importFile = null">
            <font-awesome-icon icon="times"/>
          </b-button>
        </b-list-group>
      </b-card>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button class="custom-btn-secondary mr-2" @click="hideModal">
            Отменить
          </b-button>
          <b-button class="custom-btn-primary" :disabled="loading" @click="importTasks">
            <b-spinner v-if="loading" small/>
            <v-icon name="buttons/export" :size="12"/>
            Импортировать
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import tasks from "../../network/tasks";
import locations from "../../network/locations";
import users from "../../network/users";
import workers from "../../network/workers";
import customers from "../../network/customers";
  import dateFormatter from "../../utilites/dateFormatter";
  import * as XLSX from "xlsx";
  import taskService from "./taskService";
  import helpers from "../../utilites/helpers";
    import LocationSelect from "../Locations/LocationSelect.vue";
    import LocationWorksSelect from "../Locations/LocationWorksSelect.vue";
    import UserSelect from "../Users/UserSelect.vue";

export default {
  name: "TasksImport",
  components: { UserSelect, LocationWorksSelect, LocationSelect },
  mixins: [
    tasks, locations, users, workers, customers,
    dateFormatter, taskService, helpers
  ],
  data() {
    return {
      newItem: this.setNewItem(),
      user: null,
      importFile: null,
      isBusy: false,
      loading: false,
    }
  },
  methods: {
    setNewItem() {
      return {
        id: null,
        start_address: '',
        end_address: '',
        start_date: '',
        end_date: '',
        payment_type_int: 0,
        payment_first: 0,
        payment_second: 0,
        payment_first_count: 0,
        payment_second_count: 0,
        workers_count: 0,
        total_hours: 0,
        total_price: 0,
        total_worker_price: 0,
        total_worker_price_with_comiss: 0,
        total_delta: 0,
        total_manager: 0,
        additional_cost: 0,
        additional_income: 0,
        description: '',
        cargo_description: '',
        customer_id: 0,
        customer_name: '',
        author: 0,
        author_name: '',
        executor: 0,
        executor_name: '',
        paid: false,
        contact: '',
        declarated_cost: 0,
        task_workers: [],
        location_id: 0,
        location_name: '',
        read_only: false,
        executor_rate: 0,
        town_id: null,
        work_type_id: 1,
        unit_code: "539",
        plan_workers_count: 0,
        status_id: 1,
        management_cost: 0,
        smz_cost: 0,
        status_pay: 'unpaid',
        rate_type: 1,
        project_id: null,
        project_name: '',
        project_rate: null,
        total_project: null,
        invoice_id: null,
        invoice_numb: null,
        task_location_works: [],
        profit_tax: 0,
        nds: 0,
        transfer_commission: 0,
        bank_commission: 0,
        ip_commission: 0,
        location_users: []
      };
    },
    async showModal() {
      this.resetState();
      this.user = (await this.getUserInfo()).data;

      this.newItem.author = this.user.id;
      this.newItem.author_name = this.user.name;
      this.newItem.executor = this.user.id;
      this.newItem.executor_name = this.user.name;

      this.$refs.modal_import_file.show();
    },
    hideModal() {
      this.$refs.modal_import_file.hide();
      this.resetState();
    },
    resetState() {
      this.newItem = this.setNewItem();
      this.importFile = null;
      this.user = null;

      if (this.$refs.location_select) this.$refs.location_select.onClear();
      if (this.$refs.location_works_select) this.$refs.location_works_select.onClear();
      if (this.$refs.user_select) this.$refs.user_select.onClear();
    },
    async importTasks(event) {
      if (event) event.preventDefault();

      if (!this.newItem.location_id) {
        this.showSubmitError("Выберите объект.");
        return;
      }

      if (!this.newItem.start_address) {
        this.showSubmitError("Заполните адрес заявки.");
        return;
      }

      if (!this.newItem.executor) {
        this.showSubmitError("Выберите менеджера.");
        return;
      }

      if (this.newItem.task_location_works.length === 0) {
        this.showSubmitError("Выберите вид работ объекта.");
        return;
      }

      if (!this.importFile) {
        this.showSubmitError("Выберите файл для импорта.");
        return;
      }

      this.isBusy = true;

      const data = await this.readExcel();

      if (data && data.length > 0) {
        const result = await this.handleData(data);

        if (result) {
          this.isBusy = false;
          this.$emit('refresh');
          this.hideModal();
        }
      } else {
        this.isBusy = false;
        this.showSubmitError("Файл пуст или имеет неверный формат.");
      }
    },
    async readExcel() {
      const file = this.importFile;
      const buffer = await file.arrayBuffer();
      const wb = XLSX.read(buffer);

      if (wb.SheetNames.length === 0) return [];

      const ws = wb.Sheets[wb.SheetNames[0]];

      return XLSX.utils.sheet_to_json(ws, { raw: false, range: 1 });
    },
    async handleData(data) {
      const tasksGroupedByDate = this.aggregate(data, "start_date", "workers");
      const tasks = [];

      for (const taskGroup of tasksGroupedByDate) {
        const workersData = taskGroup.workers;

        if (workersData.length === 0) continue;

        const taskItem = JSON.parse(JSON.stringify(this.newItem));
        const firstWorker = workersData[0];

        taskItem.plan_workers_count = this.parseExcelFloat(firstWorker.plan_workers_count, taskItem.plan_workers_count);

        const startD = this.formatServerDateTime(this.normalizeExcelDate(firstWorker.start_date), firstWorker.startTime);
        const endD = this.formatServerDateTime(this.normalizeExcelDate(firstWorker.endDate), firstWorker.endTime);

        if (startD.includes("NaN") || endD.includes("NaN")) {
          this.showSubmitError(`Ошибка формата даты у работника ID: ${firstWorker.worker_id}. Ожидается формат ДД.ММ.ГГГГ или ГГГГ-ММ-ДД.`);
          return false;
        }

        taskItem.start_date = startD;
        taskItem.end_date = endD;

        const workerDTOs = await Promise.all(workersData.map(w => this.getWorker(w.worker_id)));

        const taskWorkers = workersData
          .map((wData, k) => workerDTOs[k] ? this.makeWorker(workerDTOs[k], wData, taskItem) : null)
          .filter(Boolean);

        if (taskWorkers.length > 0) {
          taskItem.task_workers = taskWorkers;
          taskItem.workers_count = taskWorkers.length;

          this.updateTotals(taskItem);
          tasks.push(taskItem);
        }
      }

      if (tasks.length === 0) {
        this.showSubmitError("Не найдено заявок для сохранения.");
        return false;
      }

      const result = await this.postTasksBatch(tasks);
      if (!result || !result.data) {
        this.showSubmitError("Ошибка при сохранении заявок.");
        return false;
      }

      return true;
    },
    async getWorker(id) {
      const result = await this.getWorkerById(id);
      if (!result || !result.data) return null;
      return result.data;
    },
    makeWorker(workerDTO, workerData, task) {
      const workerStart = this.formatServerDateTime(
        this.normalizeExcelDate(workerData.startDate || task.start_date),
        workerData.startTime
      );
      const workerEnd = this.formatServerDateTime(
        this.normalizeExcelDate(workerData.endDate || task.end_date),
        workerData.endTime
      );

      const fromServerST = this.getDateFromServerString(workerStart);
      const fromServerET = this.getDateFromServerString(workerEnd);

      const tw = {
        worker_id: workerDTO.id,
        name: workerDTO.name || '',
        phone: workerDTO.phone || '',
        inn: workerDTO.inn || '',

        price: this.parseExcelFloat(workerData.worker_price, 0),
        road_price: workerData.road_price !== undefined ? this.parseExcelFloat(workerData.road_price) : (workerDTO.road_price || 0),
        prepaid: workerData.prepaid !== undefined ? this.parseExcelFloat(workerData.prepaid) : (workerDTO.prepaid || 0),
        dinner: workerData.dinner !== undefined ? this.parseExcelFloat(workerData.dinner) : (workerDTO.dinner || 0),
        description: workerData.worker_description || '',

        start_date: task.start_date,
        end_date: task.end_date,
        start_time: this.formatTime(fromServerST),
        end_time: this.formatTime(fromServerET),
        string_start_date: this.formatDate(fromServerST),
        string_end_date: this.formatDate(fromServerET),

        paid: Boolean(workerData.worker_paid),
        status_pay: 'unpaid',
        total_units: this.parseExcelFloat(workerData.worker_total_units, 1),
        task_worker_services: [],
        has_integration_details: false,
        worker: workerDTO
      };

      tw.total_price = this.calculateTotalWorkerPrice(tw);

      return tw;
    },
    updateTotals(task) {
      task.total_worker_price = this.calculateWorkersPrice(task.task_workers);

      const smzFactor = task.smz_cost > 0 ? (task.smz_cost / 100) : 0;
      task.total_worker_price_with_comiss = task.total_worker_price * (1 + smzFactor);

      task.total_hours = this.calculateWorkersHours(task.task_workers);
      task.total_price = this.calculateTotalPrice(task);
      task.total_delta = this.calculateTotalDelta(task);

      const rateType = task.rate_type || 1;
      task.total_manager = rateType === 2
        ? this.calculateTotalDeltaWithRateUnits(task.total_hours, task.executor_rate || 0)
        : this.calculateTotalDeltaWithRatePercent(task.total_delta, task.executor_rate || 0);

      if (task.project_id) {
        task.total_project = rateType === 2
          ? Math.round(task.total_hours * (task.project_rate || 0) * 100) / 100
          : Math.round((task.total_delta - task.total_manager) * (task.project_rate || 0) * 100) / 100;
      } else {
        task.total_project = 0;
      }
    },
    aggregate(items, groupByKey, itemsArrayKey) {
      if (items === undefined || items.length === 0) {
        return [];
      }
      const data = items.reduce((acc, currentItem) => {
        const groupValue = currentItem[groupByKey];

        if (acc[groupValue] === undefined) {
          acc[groupValue] = {
            [groupByKey]: groupValue,
            [itemsArrayKey]: []
          };
        }

        acc[groupValue][itemsArrayKey].push(currentItem);

        return acc;
      }, {});

      return Object.values(data);
    },
    async onLocationChange(locationId) {
      if (!locationId) {
        this.newItem = this.setNewItem();

        if (this.$refs.location_works_select) {
          this.$refs.location_works_select.onClear();
        }

        if (this.$refs.user_select) {
          this.$refs.user_select.onClear();
        }
        return;
      }

      this.loading = true;
      const result = await this.getLocationById(locationId);

      if (!result|| !result.data) {
        this.showSubmitError("Ошибка при загрузке данных объекта.");
        this.loading = false;
        return;
      }

      const location = result.data;

      this.newItem.location_id = location.id;
      this.newItem.location_name = location.name;
      this.newItem.town_id = location.town_id;
      this.newItem.customer_id = location.customer_id;
      this.newItem.customer_name = location.customer_name !== '' ? location.customer_name : '';
      this.newItem.payment_type_int = location.payment_type;
      this.newItem.management_cost = location.management_cost || 0;
      this.newItem.smz_cost = location.smz_cost || 0;
      this.newItem.profit_tax = location.profit_tax || 0;
      this.newItem.nds = location.nds || 0;
      this.newItem.transfer_commission = location.transfer_commission || 0;
      this.newItem.bank_commission = location.bank_commission || 0;
      this.newItem.ip_commission = location.ip_commission || 0;
      this.newItem.start_address = location.address;
      this.newItem.rate_type = location.rate_type || 1;
      this.newItem.location_users = location.location_users || [];


      if (!this.newItem.customer_name) {
        const customerResult = await this.getCustomerById(this.newItem.customer_id);
        this.newItem.customer_name = customerResult.data.name;
      }

      const projectUser = this.newItem.location_users.find(item => item.location_position_id === 1);

      if (projectUser) {
        this.newItem.project_id = projectUser.user_id;
        this.newItem.project_rate = projectUser.rate;

        const projectUserResult = await this.getUserById(projectUser.user_id);

        if (projectUserResult && projectUserResult.data) {
          this.newItem.project_name = projectUserResult.data.name;
        }
      } else {
        this.newItem.project_id = null;
        this.newItem.project_rate = null;
        this.newItem.project_name = '';
      }

      if (this.$refs.location_works_select) {
        const locationWorks = location.locations_work_types || [];
        await this.$refs.location_works_select.configure(0, locationWorks);
      }

      if (this.$refs.user_select) {
        await this.$refs.user_select.configure(this.newItem.executor, this.newItem.location_id, 2);
      }

      this.updateExecutorRate();
      this.loading = false;
    },
    onLocationWorkSelect(locationWork) {
      if (!locationWork) {
        this.newItem.task_location_works = [];
        this.newItem.payment_first = 0;
        this.newItem.work_type_id = 1;
        this.newItem.unit_code = "539";
        return;
      }

      this.newItem.work_type_id = locationWork.work_type_id;
      this.newItem.unit_code = locationWork.unit_code;
      this.newItem.payment_first = locationWork.rate;

      this.newItem.task_location_works = [{
        task_id: this.newItem.id,
        location_id: this.newItem.location_id,
        location_work_id: locationWork.id,
        work_type_id: locationWork.work_type_id,
        work_type_name: locationWork.work_type_name,
        rate: locationWork.rate,
        unit_code: locationWork.unit_code
      }];
    },
    async onSelectExecutor(userId, userName) {
      if (userId === 0) {
        this.newItem.executor = 0;
        this.newItem.executor_name = '';
        return;
      }

      this.newItem.executor = userId;
      this.newItem.executor_name = userName;
      this.updateExecutorRate();
    },
    updateExecutorRate() {
      const locationUser = this.newItem.location_users.find(
        x => x.user_id === this.newItem.executor && x.location_position_id === 2
      );
      const executorRate = locationUser ? locationUser.rate : 0;

      if (executorRate !== this.newItem.executor_rate) this.newItem.executor_rate = executorRate;
    },
    //
    normalizeExcelDate(rawDate) {
      if (!rawDate) return '';

      if (typeof rawDate === 'number') {
        const date = new Date(Date.UTC(1899, 11, 30));
        date.setUTCDate(date.getUTCDate() + rawDate);
        return date.toISOString().split('T')[0];
      }

      return String(rawDate).trim().replace(/^(\d{2})\.(\d{2})\.(\d{4})$/, '$3-$2-$1');
    },
    parseExcelFloat(val, fallback = 0) {
      if (val == null || val === '') return fallback;

      const num = Number(String(val).replace(',', '.'));
      return Number.isNaN(num) ? fallback : num;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tasks/TasksImport.vue